import { makeStyles } from '@material-ui/core/styles';
// import Configuration from './configuration';

export const FORM_FIELDS_COLOR = '#DEDEDE';

const useStyles = makeStyles((theme) => ({
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
  },
  formField: {
    marginTop: '16px',
  },
  submit: {
    backgroundColor: '#024C7A',
    margin: theme.spacing(3, 0, 3),
    padding: '.75rem .5rem',
    width: '85%',
    alignSelf: 'center',
    borderRadius: '24px',
    '&:hover': {
      backgroundColor: '#024C7A',
      opacity: '.9',
    },
  },
  formControl: {},
  layout_links: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    margin: 25,
  },
  // input
  input: {
    color: FORM_FIELDS_COLOR,
  },
  inputLabel: {
    color: FORM_FIELDS_COLOR,
    '&.Mui-focused': {
      color: FORM_FIELDS_COLOR,
    },
  },
  inputLabelFocus: {},
  inputIcon: {
    color: FORM_FIELDS_COLOR,
  },
  notchedOutline: {
    borderWidth: '1px !important',
    borderColor: `${FORM_FIELDS_COLOR} !important`,
    color: `${FORM_FIELDS_COLOR} !important`,
    borderRadius: '25px',
  },
  notchedOutlineFocus: {
    borderWidth: '1px',
    borderColor: `${FORM_FIELDS_COLOR} !important`,
  },
  link: {
    color: 'inherit !important',
  },
  radioButton: {
    color: FORM_FIELDS_COLOR,
  },
  selectIcon: {
    color: 'white',
  },
}));

export default useStyles;
